import { tv } from 'tailwind-variants'

import { body2 } from '@ui-kit/core/typography'

export const iconTextRow = tv({
  slots: {
    container: 'flex flex-row items-start gap-x-3',
    text: ['flex-1', body2({ color: 'black', weight: 'semibold' })],
  },
})
